@if(isLoading) {
  <app-payment-page-skeleton />
} @else {
<div class="container-fluid py-3">
  <div class="row">

    <div 
      class="col-12 bg-white py-3 px-3 rounded mb-2 text-decoration-none text-dark">
      <div class="row">

        <div class="col d-flex align-items-center">
          <h4 class="m-0"><b>
            {{ charge?.createdAt | dateToMoment: 'MMMM YYYY' }}
          </b></h4>
        </div>

        <div class="col">
          <div class="row">

            <div class="col text-danger d-flex align-items-center">
              <i class="material-icons me-2">cancel</i>{{ charge?.overdue }}
            </div>
            <div class="col text-secondary d-flex align-items-center">
              <i class="material-icons me-2">pending</i>{{ charge?.pending }}
            </div>
            <div class="col text-success d-flex align-items-center">
              <i class="material-icons me-2">check_circle</i>{{ charge?.done }}
            </div>

          </div>
        </div>

        <div class="col text-center">
          {{ charge?.charge | currency }}
        </div>

      </div>
    </div>

    <div
      class="col-12 bg-white py-3 px-3 rounded mb-3">
      <div class="row align-items-center">

        <div class="col-12 col-lg-4 d-flex align-items-center mb-2 mb-lg-0 paymentPage__toolbarCol">

          <button
            (click)="downloadReport()"
            class="btn btn-primary d-flex align-items-center justify-content-center me-2"
            type="button">
            <i class="material-icons me-2">download</i> Descargar reporte
          </button>

        </div>

        <div class="col-12 col-lg-8 paymentPage__toolbarCol">

          <div class="input-group paymentPage__search">

            <span class="input-group-text bg-white border-end-0 text-secondary paymentPage__searchAddon">
              <i class="material-icons" aria-hidden="true">search</i>
            </span>

            <input
              #housesFlatsSearchInput
              type="search"
              class="form-control border-start-0 paymentPage__searchInput"
              [class.border-end-0]="housesFlatsSearch.length > 0"
              placeholder="Buscar casa..."
              autocomplete="off"
              aria-label="Buscar casa por calle, número, propietario, notas, monto o estatus"
              [ngModel]="housesFlatsSearch"
              (ngModelChange)="onHousesFlatsSearchChange($event)"
              (keydown.escape)="clearHousesFlatsSearch(housesFlatsSearchInput)">

            @if(housesFlatsSearch.length > 0) {

              <button
                (click)="clearHousesFlatsSearch(housesFlatsSearchInput)"
                type="button"
                ngbTooltip="Limpiar búsqueda"
                container="body"
                aria-label="Limpiar búsqueda"
                class="btn paymentPage__searchClear">
                <i class="material-icons" aria-hidden="true">close</i>
              </button>

            }

          </div>

        </div>

      </div>
    </div>

    @for (item of streetsBuildingsFiltered; track item.streetBuilding.streetBuildingId) {

      <div class="col-12 text-secondary mb-1">
        <small><b>{{ item.streetBuilding.name }}</b></small>
      </div>

      <div class="col-12 bg-white px-3 rounded mb-4">
        <div class="row">
  
          @for(houseFlat of item.housesFlats; track houseFlat.houseFlatId) {
  
            <div class="col-12 py-2 border-bottom">
              <div class="row">
  
                <div class="col-2 col-lg-1 d-flex align-items-center" style="min-width: 0;">
                  {{ houseFlat.number }}
                </div>

                <div class="col-4 col-lg-2 d-flex align-items-center" style="min-width: 0;">
                  <span class="text-truncate">{{ houseFlat.fullName }}</span>
                  @if(houseFlat.creditBalance > 0) {
                    <span class="badge text-bg-info ms-1 flex-shrink-0">
                      ${{ houseFlat.creditBalance | number:'1.2-2' }} crédito
                    </span>
                  }
                </div>

                <div class="col-2 col-lg-1 text-end d-flex align-items-center justify-content-end" style="min-width: 0;">
                  {{ (houseFlat.payment?.charge ?? ((houseFlat.movement?.amount ?? 0) + (houseFlat.movement?.creditApplied ?? 0))) | currency }}
                </div>

                <div class="col-lg-1 d-none d-lg-flex align-items-center" style="min-width: 0;">
                  <div style="overflow: hidden; max-height: 3rem; min-width: 0;">
                    <div [innerHTML]="houseFlat.notes | newlineToBr"></div>
                  </div>
                </div>

                <div class="col-lg-2 d-none d-lg-flex align-items-center" style="min-width: 0;">
                  <div style="overflow: hidden; max-height: 3rem; min-width: 0;">
                    <div [innerHTML]="(houseFlat.payment?.notes ?? houseFlat.movement?.notes ?? '') | newlineToBr"></div>
                  </div>
                  @if(((houseFlat.payment?.creditApplied ?? houseFlat.movement?.creditApplied) ?? 0) > 0) {
                    <span class="badge text-bg-info ms-2 flex-shrink-0">
                      Crédito: ${{ (houseFlat.payment?.creditApplied ?? houseFlat.movement?.creditApplied) | number:'1.2-2' }}
                    </span>
                  }
                </div>

                <div class="col-4 col-lg-2 d-flex align-items-center" style="min-width: 0;">
                  @if(houseFlat.payment) {

                    <div ngbDropdown placement="bottom-start auto">

                      @if(houseFlat.payment.status === true) {
                        <span class="badge rounded-pill text-bg-success"
                          style="cursor: pointer;" ngbDropdownToggle>
                          Pagado
                        </span>
                      } @else if(houseFlat.payment.status === false) {
                        <span class="badge rounded-pill text-bg-secondary"
                          style="cursor: pointer;" ngbDropdownToggle>
                          Pendiente
                        </span>
                      } @else {
                        <span class="badge rounded-pill text-bg-danger"
                          style="cursor: pointer;" ngbDropdownToggle>
                          Sin pago
                        </span>
                      }

                      <div ngbDropdownMenu>

                        <button ngbDropdownItem class="d-flex align-items-center"
                          (click)="updateStatus(item.streetBuilding, houseFlat, null)">
                          <i class="material-icons text-primary me-2" style="font-size: 18px;">
                            {{ (houseFlat.payment.status ?? null) === null ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span>Sin pago</span>
                        </button>

                        <button ngbDropdownItem class="d-flex align-items-center"
                          (click)="updateStatus(item.streetBuilding, houseFlat, false)">
                          <i class="material-icons text-primary me-2" style="font-size: 18px;">
                            {{ houseFlat.payment.status === false ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span>Pendiente</span>
                        </button>

                        <button ngbDropdownItem class="d-flex align-items-center"
                          (click)="updateStatus(item.streetBuilding, houseFlat, true)">
                          <i class="material-icons text-primary me-2" style="font-size: 18px;">
                            {{ houseFlat.payment.status === true ? 'check_circle' : 'radio_button_unchecked' }}
                          </i>
                          <span>Pagado</span>
                        </button>

                      </div>
                    </div>

                  } @else if(houseFlat.movement) {

                    @if((houseFlat.movement.creditApplied ?? 0) > 0 && houseFlat.movement.amount === 0) {

                      @if(houseFlat.movement.status === true) {
                        <span class="badge rounded-pill text-bg-success"
                          placement="top" ngbTooltip="Pagado con crédito">
                          Pagado
                        </span>
                      } @else if(houseFlat.movement.status === false) {
                        <span class="badge rounded-pill text-bg-danger">Sin pago</span>
                      } @else {
                        <span class="badge rounded-pill text-bg-secondary">Pendiente</span>
                      }

                    } @else {

                      <div ngbDropdown placement="bottom-start auto">

                        @if(houseFlat.movement.status === true) {
                          <span class="badge rounded-pill text-bg-success"
                            style="cursor: pointer;" ngbDropdownToggle>
                            Pagado
                          </span>
                        } @else if(houseFlat.movement.status === false) {
                          <span class="badge rounded-pill text-bg-danger"
                            style="cursor: pointer;" ngbDropdownToggle>
                            Sin pago
                          </span>
                        } @else {
                          <span class="badge rounded-pill text-bg-secondary"
                            style="cursor: pointer;" ngbDropdownToggle>
                            Pendiente
                          </span>
                        }

                        <div ngbDropdownMenu>

                          <button ngbDropdownItem class="d-flex align-items-center"
                            (click)="updateMovementStatus(houseFlat, false)">
                            <i class="material-icons text-primary me-2" style="font-size: 18px;">
                              {{ houseFlat.movement.status === false ? 'check_circle' : 'radio_button_unchecked' }}
                            </i>
                            <span>Sin pago</span>
                          </button>

                          <button ngbDropdownItem class="d-flex align-items-center"
                            (click)="updateMovementStatus(houseFlat, null)">
                            <i class="material-icons text-primary me-2" style="font-size: 18px;">
                              {{ (houseFlat.movement.status ?? null) === null ? 'check_circle' : 'radio_button_unchecked' }}
                            </i>
                            <span>Pendiente</span>
                          </button>

                          <button ngbDropdownItem class="d-flex align-items-center"
                            (click)="updateMovementStatus(houseFlat, true)">
                            <i class="material-icons text-primary me-2" style="font-size: 18px;">
                              {{ houseFlat.movement.status === true ? 'check_circle' : 'radio_button_unchecked' }}
                            </i>
                            <span>Pagado</span>
                          </button>

                        </div>
                      </div>

                    }

                  } @else {

                    <span class="badge rounded-pill text-bg-danger">
                      Sin pago
                    </span>

                  }
                </div>
  
                <div class="col-12 col-lg-3 d-flex align-items-center justify-content-around justify-content-lg-start" style="min-width: 0;">
  
                  <p-inputSwitch
                    class="me-2"
                    (onChange)="update(houseFlat)"
                    [(ngModel)]="houseFlat.status">
                  </p-inputSwitch>

                  <button
                    (click)="openPayment(item.streetBuilding, houseFlat)"
                    class="btn btn-sm btn-light rounded-circle me-2 my-1"
                    placement="top"
                    ngbTooltip="Registrar pago">
                    <i class="material-icons mt-1">payments</i>
                  </button>

                  <button
                    (click)="openHouseFlat(houseFlat)"
                    class="btn btn-sm btn-light rounded-circle me-2 my-1"
                    placement="top"
                    ngbTooltip="Editar casa">
                    <i class="material-icons mt-1">edit</i>
                  </button>

                  <button
                    class="btn btn-sm btn-light rounded-circle me-2 my-1"
                    placement="top"
                    ngbTooltip="Ver pagos y crédito"
                    [routerLink]="[
                      '/neighborhoods',
                      neighborhoodId,
                      'streets-buildings',
                      houseFlat.streetBuildingId,
                      'houses-flats',
                      houseFlat.houseFlatId,
                      'payments'
                    ]">
                    <i class="material-icons mt-1">account_balance_wallet</i>
                  </button>
  
                  <!-- <a
                    [routerLink]="[houseFlat.houseFlatId]"
                    class="btn btn-sm btn-light rounded-circle me-2 my-1">
                    <i class="material-icons mt-1">more_vert</i>
                  </a> -->
                </div>
  
              </div>
            </div>
  
          }
  
          @if(item.housesFlats.length === 0) {
            <div class="col-12 text-center">
              <small class="text-secondary">
                No hay casas registradas
              </small>
            </div>
          }
  
        </div>
      </div>  

    }

    <div class="col-12 text-center" role="status" aria-live="polite">
      @if(streetsBuildingsFiltered.length === 0 && housesFlatsSearch.length > 0) {
        <small class="text-secondary">
          No hay resultados para tu búsqueda
        </small>
      }
    </div>

  </div>
</div>
}